import { useEffect, useState } from "react";
import { siteThumbUrl, thumbUrl } from "@/lib/images";

/** Kachelbild: kleine WebP-Variante (Website-Bilder) bzw. _thumb (Objektbilder); fehlt die Variante, wird das Original geladen. */
export const SiteImg = ({ src, ...props }) => {
  const small = siteThumbUrl(src) || thumbUrl(src) || src;
  const [cur, setCur] = useState(small);
  useEffect(() => { setCur(small); }, [small]);
  return <img src={cur} onError={() => { if (cur !== src) setCur(src); }} {...props} />;
};
